/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from "@angular/core";
import { CofaceCountriesResourceService } from '@well/common-libs/legal-entity-management/data-access';

@Injectable({
  providedIn: 'root'
})
export class CompanyCountryDropdownService {

  constructor(private cofaceCountriesResourceService: CofaceCountriesResourceService){

  }

  getCountries() {
    return this.cofaceCountriesResourceService.getCountries();
  }
}
